<template>
    <div>
        Products
    </div>
</template>

<script>
export default {
    name: 'product-page',
}
</script>

<style lang="scss" scoped>

</style>